import React from 'react';
import { Button, message } from 'antd';
import dayjs from 'dayjs';
import useService from '@/lib/hooks/useService';
import sendNotification from '@/lib/sendMessage';
import type { OrderForTableReceive } from '../types';
import type { ResidentAccountNumber } from '@/types/database/residentAccountNumbers';

interface NoticeResidentsProps {
  order: OrderForTableReceive;
}

const NoticeResidents = ({ order }: NoticeResidentsProps) => {
  const [hasMembersResidents] = useService<ResidentAccountNumber>({
    collectionName: 'residentAccountNumbers',
    query: {
      $and: [
        { $expr: { $gt: [{ $size: '$members' }, 0] } },
        { members: { $exists: true } },
      ],
    },
  });
  const hasMembersHouseholdNumbers = hasMembersResidents.map(
    (residentObj) => residentObj.householdNumber
  );

  const noticeResidents = () => {
    const data = {
      title: '個人通知',
      content: `${
        order.itemName
      }團購開始囉，請各位踴躍參與訂購!-${dayjs().format('YYYY/MM/DD HH:mm')}`,
      class: 'message',
      redirect: '/ezpro/personalNotice',
      query: {
        householdNumbers: {
          $in: hasMembersHouseholdNumbers,
        },
        firebaseClass: '社區管理',
      },
    };
    sendNotification(data);
    message.success('已傳送推播給住戶');
  };

  return <Button onClick={noticeResidents}>推播通知</Button>;
};

export default NoticeResidents;
